module.exports = __webpack_public_path__ + "img/logo_w.98ea8ce6.png";